import { useContext } from 'react'

import {
  TranslationContext,
  type TranslationContextProps,
} from '../context/TranslationContext'

/**
 *
 */
export function useTranslations(): TranslationContextProps {
  return useContext(TranslationContext)
}
